import * as sip from './sip';
export * as sip from './sip';

import * as common from './common';
export * as common from './common';

export default {
  common,
  sip
};
